import {INVE_FIELDS} from '@/constants/inve';
import {J_ARRAYS, J_ARRAYS_TYPE_FIELD} from '@/model/src/sections/section-j-plus/constants';
import {DV_32} from '@/model/src/values/dv-32';
import {FeeType} from '@/model/src/values/dv-33';
import {DV_46} from '@/model/src/values/dv-46';
import {Country} from '@/model/src/values/dv-47';
import {DV_85} from '@/model/src/values/dv-85';
import {ContractTypes} from '@/model/src/values/dv-93';
import {DV_95} from '@/model/src/values/dv-95';
import {DV_96} from '@/model/src/values/dv-96';
import {ValueStringReference} from '@/model/types';
import {AllocationAccountType} from '@/repositories/beneva-api/endpoints/allocations';

export const STATE_VALUE_WILDCARD_SUFFIX = '*';
export const DOCUMENT_LOCALE_FIELD_ID = 'A0';
export const DOMAIN_VALUE_LANGUAGES_ID = 'DV-1';
export const USER_PROFILE_FIELD_PREFIX = 'user';
export const ADVISOR_PROFILE_FIELD_PREFIX = 'cons';

export const INVESTOR_PROFILE_FIELD_PREFIX = 'inve';
export const INVESTOR_BANK_ACCOUNT_FIELD_IDS = [
  INVE_FIELDS.INVE34_bankAccountBankNo,
  INVE_FIELDS.INVE35_bankAccountTransit,
  INVE_FIELDS.INVE36_bankAccountFolio,
  INVE_FIELDS.INVE37_bankAccountMasked,
  INVE_FIELDS.INVE38_bankAccountBankName,
  INVE_FIELDS.INVE39_bankAccountHolder,
] as const;

export const ACCOUNT_FIELD_PREFIX = 'comp';
export const SOURCE_ACCOUNT_FIELD_PREFIX = 'prv_comp';
export const META_FIELD_PREFIX = '_';
export const ARRAY_META_FIELD_IS_MODAL_OPEN = '[open]';
export const ARRAY_META_FIELD_FIELDS_REF = '[fields]';
export const ARRAY_META_FIELD_DRAFT = '[draft]';
export const ARRAY_META_FIELD_IS_NEW = '[new]';
export const ARRAY_META_FIELD_COUNT = '[count]';
export const ARRAY_META_FIELDS = [
  ARRAY_META_FIELD_IS_MODAL_OPEN,
  ARRAY_META_FIELD_FIELDS_REF,
  ARRAY_META_FIELD_DRAFT,
  ARRAY_META_FIELD_IS_NEW,
  ARRAY_META_FIELD_COUNT,
];
export const BENEVA_CODE_SEPARATOR = 'R';

// Constants for the predetermined allocations plugin
export const USER_PROFILE_ALLOCATIONS = 'ALLOCATIONS';
export const DOMAIN_VALUE_ALLOCATION_INVESTMENT_ACCOUNTS = 'DV-32';
export const DOMAIN_VALUE_ALLOCATION_GUARANTEED_FUNDS_ACCOUNTS = 'DV-95';
export const FORM_ALLOCATIONS_FIELD_PREFIX = 'J_predeterminedAllocation|';
export const BENEVA_INVESTMENT_ACCOUNT_CODE_PREFIX = 'C_benevaInvestmentAccountCodePrefix';

export const FORM_FIELD_ALLOCATION_SELECTED = `${FORM_ALLOCATIONS_FIELD_PREFIX}J17`;
export const FORM_FIELD_ALLOCATION_FEES = `${FORM_ALLOCATIONS_FIELD_PREFIX}J18`;
export const FORM_FIELD_ALLOCATION_DEPOSIT_TYPE = `${FORM_ALLOCATIONS_FIELD_PREFIX}depositType`;
export const FORM_FIELD_ALLOCATION_INVESTMENT_ROUNDED = `${FORM_ALLOCATIONS_FIELD_PREFIX}investmentRounded`;
export const FORM_FIELD_ALLOCATION_EXISTING_INVESTMENT = `${FORM_ALLOCATIONS_FIELD_PREFIX}existingInvestment`;
export const FORM_FIELD_ALLOCATION_MAXIMUM_EXCEEDED = `${FORM_ALLOCATIONS_FIELD_PREFIX}maximumExceeded`;
export const FORM_FIELD_ALLOCATION_MAX_BENEVA_INVESTMENT_ACCOUNTS = `${FORM_ALLOCATIONS_FIELD_PREFIX}maxBenevaInvestmentAccounts`;
export const FORM_FIELD_ALLOCATION_MAX_BENEVA_GUARANTEED_FUNDS = `${FORM_ALLOCATIONS_FIELD_PREFIX}maxBenevaGuaranteedInvestmentFunds`;
export const FORM_FIELD_ALLOCATION_FIRST_ACCOUNT = `${FORM_ALLOCATIONS_FIELD_PREFIX}firstAccount`;

export const FORM_FIELD_ALLOCATIONS_AMOUNT_PERIODIC = `${FORM_ALLOCATIONS_FIELD_PREFIX}J19`;
export const FORM_FIELD_ALLOCATIONS_AMOUNT_CASH_INPUT = `${FORM_ALLOCATIONS_FIELD_PREFIX}J20_input`;
export const FORM_FIELD_ALLOCATIONS_AMOUNT_CASH_COMPUTED = `${FORM_ALLOCATIONS_FIELD_PREFIX}J20`;
export const FORM_FIELD_ALLOCATIONS_AMOUNT_EFT_INPUT = `${FORM_ALLOCATIONS_FIELD_PREFIX}J21_input`;
export const FORM_FIELD_ALLOCATIONS_AMOUNT_EFT_COMPUTED = `${FORM_ALLOCATIONS_FIELD_PREFIX}J21`;
export const FORM_FIELD_ALLOCATIONS_AMOUNT_TRANSFER = `${FORM_ALLOCATIONS_FIELD_PREFIX}J29`;

export const COMPUTED_ALLOCATION_ACCOUNTS = `${FORM_ALLOCATIONS_FIELD_PREFIX}accounts`;
export const COMPUTED_ALLOCATION_ACCOUNTS_PREFIX = `${COMPUTED_ALLOCATION_ACCOUNTS}|`;
export const COMPUTED_ALLOCATION_ACCOUNT_ID = `${COMPUTED_ALLOCATION_ACCOUNTS_PREFIX}id#{$index}`;
export const COMPUTED_ALLOCATION_ACCOUNT_TYPE = `${COMPUTED_ALLOCATION_ACCOUNTS_PREFIX}type#{$index}`;
export const COMPUTED_ALLOCATION_ACCOUNT_FEES = `${COMPUTED_ALLOCATION_ACCOUNTS_PREFIX}fees#{$index}`;
export const COMPUTED_ALLOCATION_ACCOUNT_CODE = `${COMPUTED_ALLOCATION_ACCOUNTS_PREFIX}code#{$index}`;
export const COMPUTED_ALLOCATION_INVESTMENT_ACCOUNT_CODE_TEMPLATE = `\${${BENEVA_INVESTMENT_ACCOUNT_CODE_PREFIX}}\${${COMPUTED_ALLOCATION_ACCOUNT_FEES}:id_beneva}${BENEVA_CODE_SEPARATOR}\${${COMPUTED_ALLOCATION_ACCOUNT_ID}:id_beneva}`;
export const COMPUTED_ALLOCATION_GUARANTEED_FUND_TEMPLATE = `\${C13:id_beneva}\${${COMPUTED_ALLOCATION_ACCOUNT_FEES}:id_beneva}\${${COMPUTED_ALLOCATION_ACCOUNT_ID}:id_beneva}`;
export const COMPUTED_ALLOCATION_ACCOUNT_AMOUNT = `${COMPUTED_ALLOCATION_ACCOUNTS_PREFIX}amount#{$index}`;
export const COMPUTED_ALLOCATION_ACCOUNT_AMOUNT_RAW = `${COMPUTED_ALLOCATION_ACCOUNTS_PREFIX}amount_raw#{$index}`;

export const FORM_FIELD_DEPOSIT_TYPE_MAP = new Map<string, string>([
  ['periodic', FORM_FIELD_ALLOCATIONS_AMOUNT_PERIODIC],
  ['cash', FORM_FIELD_ALLOCATIONS_AMOUNT_CASH_INPUT],
  ['eft', FORM_FIELD_ALLOCATIONS_AMOUNT_EFT_INPUT],
  ['transfer', FORM_FIELD_ALLOCATIONS_AMOUNT_TRANSFER],
  ['identicalInvestmentsFromCash', FORM_FIELD_ALLOCATIONS_AMOUNT_CASH_INPUT],
  ['identicalInvestmentsFromPeriodic', FORM_FIELD_ALLOCATIONS_AMOUNT_PERIODIC],
]);

export const FORM_ARRAY_BENEVA_ACCOUNTS = J_ARRAYS.J_benevaInvestmentAccounts;
export const FORM_FIELD_BENEVA_ACCOUNT_ID = 'J17#{$index}';
export const FORM_FIELD_BENEVA_ACCOUNT_CODE = 'J32#{$index}';
export const FORM_FIELD_BENEVA_DEPOSIT_TYPE = `${J_ARRAYS_TYPE_FIELD.J_benevaInvestmentAccounts}#{$index}` as const;
export const FORM_FIELD_BENEVA_ACCOUNT_FEES = 'J18#{$index}';
export const FORM_FIELD_BENEVA_AMOUNT_PERIODIC_INPUT = 'J19_percentage#{$index}';
export const FORM_FIELD_BENEVA_AMOUNT_PERIODIC_COMPUTED = 'J19#{$index}';
export const FORM_FIELD_BENEVA_AMOUNT_TRANSFER = 'J29#{$index}';
export const FORM_FIELD_BENEVA_AMOUNT_CASH_INPUT = 'J20_percentage#{$index}';
export const FORM_FIELD_BENEVA_AMOUNT_CASH_COMPUTED = 'J20#{$index}';
export const FORM_FIELD_BENEVA_AMOUNT_EFT_INPUT = 'J21_input#{$index}';
export const FORM_FIELD_BENEVA_AMOUNT_EFT_COMPUTED = 'J21#{$index}';
export const FORM_FIELDS_BENEVA_AMOUNT_PERIODIC = [
  FORM_FIELD_BENEVA_AMOUNT_PERIODIC_INPUT,
  FORM_FIELD_BENEVA_AMOUNT_PERIODIC_COMPUTED,
];
export const FORM_FIELDS_BENEVA_AMOUNT_CASH = [
  FORM_FIELD_BENEVA_AMOUNT_CASH_INPUT,
  FORM_FIELD_BENEVA_AMOUNT_CASH_COMPUTED,
];
export const FORM_FIELDS_BENEVA_AMOUNT_EFT = [
  FORM_FIELD_BENEVA_AMOUNT_EFT_INPUT,
  FORM_FIELD_BENEVA_AMOUNT_EFT_COMPUTED,
];
export const FORM_FIELDS_BENEVA_AMOUNT_TRANSFER = [FORM_FIELD_BENEVA_AMOUNT_TRANSFER];

export const FORM_ARRAY_BENEVA_GUARANTEED_FUNDS = J_ARRAYS.J_benevaGuaranteedInvestmentFunds;
export const FORM_FIELD_BENEVA_GUARANTEED_FUND_ID = 'J38#{$index}';
export const FORM_FIELD_BENEVA_GUARANTEED_FUND_CODE = 'J39#{$index}';
export const FORM_FIELD_BENEVA_GUARANTEED_FUND_DEPOSIT_TYPE =
  `${J_ARRAYS_TYPE_FIELD.J_benevaGuaranteedInvestmentFunds}#{$index}` as const;
export const FORM_FIELD_BENEVA_GUARANTEED_FUND_FEES = 'J40#{$index}';
export const FORM_FIELD_BENEVA_GUARANTEED_FUND_AMOUNT_PERIODIC_INPUT = 'J41_percentage#{$index}';
export const FORM_FIELD_BENEVA_GUARANTEED_FUND_AMOUNT_PERIODIC_COMPUTED = 'J41#{$index}';
export const FORM_FIELD_BENEVA_GUARANTEED_FUND_AMOUNT_TRANSFER = 'J44#{$index}';
export const FORM_FIELD_BENEVA_GUARANTEED_FUND_AMOUNT_CASH_INPUT = 'J42_percentage#{$index}';
export const FORM_FIELD_BENEVA_GUARANTEED_FUND_AMOUNT_CASH_COMPUTED = 'J42#{$index}';
export const FORM_FIELD_BENEVA_GUARANTEED_FUND_AMOUNT_EFT_INPUT = 'J43_input#{$index}';
export const FORM_FIELD_BENEVA_GUARANTEED_FUND_AMOUNT_EFT_COMPUTED = 'J43#{$index}';
export const FORM_FIELDS_BENEVA_GUARANTEED_FUND_AMOUNT_PERIODIC = [
  FORM_FIELD_BENEVA_GUARANTEED_FUND_AMOUNT_PERIODIC_INPUT,
  FORM_FIELD_BENEVA_GUARANTEED_FUND_AMOUNT_PERIODIC_COMPUTED,
];
export const FORM_FIELDS_BENEVA_GUARANTEED_FUND_AMOUNT_CASH = [
  FORM_FIELD_BENEVA_GUARANTEED_FUND_AMOUNT_CASH_INPUT,
  FORM_FIELD_BENEVA_GUARANTEED_FUND_AMOUNT_CASH_COMPUTED,
];
export const FORM_FIELDS_BENEVA_GUARANTEED_FUND_AMOUNT_EFT = [
  FORM_FIELD_BENEVA_GUARANTEED_FUND_AMOUNT_EFT_INPUT,
  FORM_FIELD_BENEVA_GUARANTEED_FUND_AMOUNT_EFT_COMPUTED,
];
export const FORM_FIELDS_BENEVA_GUARANTEED_FUND_AMOUNT_TRANSFER = [FORM_FIELD_BENEVA_GUARANTEED_FUND_AMOUNT_TRANSFER];

export const DESTINATION_FIELDS = {
  [FORM_ARRAY_BENEVA_ACCOUNTS]: {
    id: FORM_FIELD_BENEVA_ACCOUNT_ID,
    code: FORM_FIELD_BENEVA_ACCOUNT_CODE,
    fees: FORM_FIELD_BENEVA_ACCOUNT_FEES,
    depositType: FORM_FIELD_BENEVA_DEPOSIT_TYPE,
    input: {
      cash: FORM_FIELD_BENEVA_AMOUNT_CASH_INPUT,
      eft: FORM_FIELD_BENEVA_AMOUNT_EFT_INPUT,
      periodic: FORM_FIELD_BENEVA_AMOUNT_PERIODIC_INPUT,
      transfer: FORM_FIELD_BENEVA_AMOUNT_TRANSFER,
    },
    amount: {
      cash: FORM_FIELDS_BENEVA_AMOUNT_CASH,
      periodic: FORM_FIELDS_BENEVA_AMOUNT_PERIODIC,
      eft: FORM_FIELDS_BENEVA_AMOUNT_EFT,
      transfer: FORM_FIELDS_BENEVA_AMOUNT_TRANSFER,
    },
  },
  [FORM_ARRAY_BENEVA_GUARANTEED_FUNDS]: {
    id: FORM_FIELD_BENEVA_GUARANTEED_FUND_ID,
    code: FORM_FIELD_BENEVA_GUARANTEED_FUND_CODE,
    fees: FORM_FIELD_BENEVA_GUARANTEED_FUND_FEES,
    depositType: FORM_FIELD_BENEVA_GUARANTEED_FUND_DEPOSIT_TYPE,
    input: {
      cash: FORM_FIELD_BENEVA_GUARANTEED_FUND_AMOUNT_CASH_INPUT,
      eft: FORM_FIELD_BENEVA_GUARANTEED_FUND_AMOUNT_EFT_INPUT,
      periodic: FORM_FIELD_BENEVA_GUARANTEED_FUND_AMOUNT_PERIODIC_INPUT,
      transfer: FORM_FIELD_BENEVA_GUARANTEED_FUND_AMOUNT_TRANSFER,
    },
    amount: {
      cash: FORM_FIELDS_BENEVA_GUARANTEED_FUND_AMOUNT_CASH,
      periodic: FORM_FIELDS_BENEVA_GUARANTEED_FUND_AMOUNT_PERIODIC,
      eft: FORM_FIELDS_BENEVA_GUARANTEED_FUND_AMOUNT_EFT,
      transfer: FORM_FIELDS_BENEVA_GUARANTEED_FUND_AMOUNT_TRANSFER,
    },
  },
};

export {
  ACCOUNT_TYPE_TO_DV_MAPPING,
  PRODUCT_TYPE_TO_DV_MAPPING,
  GUARANTEE_TO_DV_MAPPING,
  REDEEMABLE_FLAG_TO_DV_MAPPING,
  PERIODIC_DEPOSIT_FREQUENCY_TO_DV_MAPPING,
  PERIODIC_DEPOSIT_STATUS_TO_DV_MAPPING,
} from './client-info-mappings';

export const DEFAULT_MAX_BENEVA_ACCOUNTS = 10;

export const PROVINCE_CODE_TO_DV_MAPPING = DV_46.values.reduce(
  (acc, province) => ({...acc, [province.properties.code]: `${DV_46.id}#${province.id}`}),
  {} as Record<string, string>,
);

export const COUNTRY_CODE_TO_DV_MAPPING = {
  CAN: Country.CANADA,
} as const;

export const ALLOCATION_ACCOUNT_TYPE_TO_DV_MAPPING = {
  CI: ContractTypes.CI,
  FPG: ContractTypes.FPG,
} as const satisfies Readonly<Record<AllocationAccountType, ValueStringReference>>;

const byBenevaId = (definition: {
  id: string;
  values: readonly {id: string; properties: {id_beneva: string}}[];
}): Record<string, string> =>
  definition.values.reduce<Record<string, string>>(
    (acc, {id, properties}) =>
      properties.id_beneva === '' ? acc : {...acc, [properties.id_beneva]: `${definition.id}#${id}`},
    {},
  );

export const INVESTMENT_ACCOUNT_FEE_TYPE_TO_DV_MAPPING = byBenevaId(DV_85);

export const PAC_INVESTMENT_ACCOUNT_FEE_TYPE_TO_DV_MAPPING = {
  '1': FeeType.NoLoad,
  '5': FeeType.AdvisorChargeback5Years,
  '6': FeeType.AdvisorChargeback3Years,
} as const satisfies Readonly<Record<string, ValueStringReference>>;

export const GUARANTEED_INVESTMENT_FUND_FEE_TYPE_TO_DV_MAPPING = byBenevaId(DV_96);

export const INVESTMENT_ACCOUNT_FUND_NAME_CODE_TO_DV_MAPPING = byBenevaId(DV_32);

export const GUARANTEED_INVESTMENT_FUND_NAME_CODE_TO_DV_MAPPING = byBenevaId(DV_95);
